import script from "./printerCommons.vue?vue&type=script&lang=js"
export * from "./printerCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__